import React, { FC, useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Button, Dropdown, Form, Label } from 'semantic-ui-react';
import { useForm, Controller, FieldError, FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { DevTool } from '@hookform/devtools';


import GlobalContext from '../../../contexts/GlobalContext'
import useFormFormatedList from '../../../hooks/useFormFormatedList';
import InputSelect from '../../FormInputCustomer/InputSelect/InputSelectV2'
import InputText from '../../FormInputCustomer/InputText/InputTextV2';
import { RootDispatch, RootState } from '../../../store';
import { CountryTypeEnum, IdentityEnum, PreChekInStepEnum } from '../../../common/types/checkin';
import usePreCheckInSchema from '../../../hooks/usePreckInSchema';

import "./PrincipalInfos.css"
import { string } from 'yargs';

const mapProps = (state: RootState) => ({
  checkIn: state.checkin,
  isBookerHasMailOTA: state.authentication.isBookerHasMailOTA
})

const mapDispatch = (dispatch: RootDispatch) => ({
  //TODO redéfinir correctement le typage avec Promise
  handleCheckInData: dispatch.checkin.handleData as any,
  handleStepperForm: dispatch.checkin.handleStepperForm
})

type Props = ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

type FormValues = {
  lastName : string
  society : string
  firstName : string
  mail : string
  country : string
}

const getLabel = (isMandatory, label) => {
    
  if(isMandatory === 'mandatory'){
    return { icon: { name:'asterisk', color : 'red', size : 'tiny', className : 'pl-2 float-right' }, content : label }
  }
  else{
    return {  content : label }
  }

}


const PrincipalInfos: FC<Props> = ({
  checkIn, isBookerHasMailOTA, handleStepperForm, handleCheckInData
}) => {

  // Hooks
  const [globalContext] = useContext(GlobalContext) as any
  const { listPaysSelect } = useFormFormatedList(globalContext)

  // Data
  const { translations } = globalContext
  const fieldsForm = checkIn.checkInFieldParameters[checkIn.stepperForm.fieldCheckInType]
  const identity = checkIn.stepperForm.identity
  const checkInData = checkIn.theData?.[identity]
  //const checkInData = Object.assign({}, checkIn.theData?.[identity])
  const disabledEmail = checkInData?.mail !== '' && identity === IdentityEnum.ResidentBase && !isBookerHasMailOTA;

  // Create validation schema
  //const schema = usePreCheckInSchema(fieldsForm, PreChekInStepEnum.PrincipalInfos);
  
  // useForm
  const methods = useForm<FormValues>({
              defaultValues:{
                lastName : checkInData?.lastName ?? '',
                society : checkInData?.society ?? '',
                firstName : checkInData?.firstName ?? '',
                mail : checkInData?.mail ?? '',
                country : checkInData?.country ?? '',
              },
              //resolver: yupResolver(schema),
            });
  

  //state
  const [isDataLoadingState, setIsDataLoadingState] = useState(false);

  // Dynamic assign default value to useForm because of dependencies
  useEffect(() => {

    methods.reset(checkInData)

  }, [checkInData, identity])

  const handleCountryChange = (selected, onChange) => {
    let countryType = CountryTypeEnum.Resident
    if (selected.value !== globalContext.establishment.country) countryType = CountryTypeEnum.NonResident

    handleStepperForm({countryType})
    onChange(selected.value)
  }

  const onSubmit = async (data: FormValues) => {

    setIsDataLoadingState(true);

    let hasError = false

    // Verfi nom ou societé vide
    if (data.lastName == "" && data.society == "") {
      methods.setError("lastName", {
        type: "requiredDouble",
        message: translations.modalCheckInFormPartOneLastnameError + ' ' + translations.doubleInputChoiceWording + ' ' + translations.modalCheckInFormPartOneSocietyError,
      });
      hasError = true
    }

    if (!hasError) {
      let dataToReturn: any = {
        lastName: data.lastName,
        society: data.society,
        firstName: data.firstName,
        mail: data.mail,
        country: data.country
      };
  
      /*if (fieldsForm.mobile !== 'deactivated' && data.country !== "" && (Object.keys(checkInData).length === 0 || checkInData.mobileCode === "")) {
        let matchedCountry = globalContext.countries.find(countryItem => {
          return countryItem.iso === data.country;
        });
        dataToReturn.mobileCode = `${matchedCountry.telephoneCode}__${matchedCountry.iso}`
      }*/
      handleCheckInData({ [identity]: dataToReturn})
        .then(() => {
          setIsDataLoadingState(false);
          handleStepperForm({step: PreChekInStepEnum.SecondaryInfos});
        })
        .catch(err => console.log({err}))
    }
    setIsDataLoadingState(false);
    
  };


  const { control, formState } = methods
  const { errors } = formState

  return (
    <div>
      <Form onSubmit={methods.handleSubmit(onSubmit)} >
        <p>{translations.modalCheckInFormPartOneTitle} : </p>  
 
        <Form.Group widths='equal'>

          {/**** NOM OU SOCIETE ****/ }
          <Controller
                name="lastName"
                render={({ field, fieldState }) => <InputText {...field} 
                                            //thelabel={translations.modalCheckInFormPartOneLastname} 
                                            label= { getLabel( fieldsForm?.nom, translations.lastName ) }
                                            errors = { errors }
                                            errorMessage = {errors.lastName?.message }
                                          />}
                control={control}
                //defaultValue={checkInData?.lastName ?? ''}
              />
          <span className="doubleInputChoiceWording">{translations.doubleInputChoiceWording}</span>     
          <Controller
                name="society"
                render={({ field }) => <InputText {...field} 
                                            //thelabel={translations.modalCheckInFormPartOneSociety}
                                            label= { getLabel( fieldsForm?.society, translations.modalCheckInFormPartOneSociety ) }
                                          />}
                control={control}
                //defaultValue={checkInData?.society ?? ''}
              />
        </Form.Group>
        
        {/**** PRENOM ****/ }
        {fieldsForm.prenom !== 'deactivated' && 
          <Controller
                name="firstName"
                render={({ field }) => <InputText {...field} 
                                            label= { getLabel( fieldsForm?.prenom, translations.modalCheckInFormPartOneFirstname ) }
                                            errorMessage = {errors.firstName?.message }
                                          />}
                control={control}
                rules={ {required: { 
                  value : fieldsForm?.prenom === 'mandatory', 
                  message : translations.modalCheckInFormPartOneFirstnameError } }  
                }
                //defaultValue={checkInData?.firstName ?? ''}
              />
        }

        {/**** EMAIL ****/ }
        {fieldsForm.email !== 'deactivated' && 
          <Controller 
            name="mail"
            render={({ field }) => <InputText {...field} 
                                            label= { getLabel( fieldsForm?.email, translations.modalCheckInFormPartOneEmail ) }
                                            errorMessage = {errors.mail?.message }
                                            disabled={disabledEmail}
                                          />}

            
            control={control}
            //defaultValue={checkInData?.mail ?? ''}
          />
        }

        {/**** PAYS ****/ }
        {fieldsForm.pays !== 'deactivated' && 
          <Controller
            name="country"
            render={({ field }) => <InputSelect {...field} //InputSelect
                                          options={listPaysSelect}
                                          onChange={(_, selected) => handleCountryChange(selected, field.onChange)}
                                          //thelabel= {  translations.modalCheckInFormPartOneEmail }
                                          //errorMessage = {errors.mail?.message }
                                          search={!isMobile}
                                        />}
            control={control}
            //defaultValue={checkInData?.country ?? ''}
          />
        }

        <div className='mt-4'>
          <Button
            loading={isDataLoadingState}
            disabled={isDataLoadingState}
            fluid
            type="submit"
            primary
            content={translations.modalCheckInNextStep}
            icon="chevron right"
            labelPosition="right"
          />
        </div>
      </Form>
      {/**** DEBUG HOOK FORM ****/ }
      {/* <DevTool control={control} /> */ }
    </div>
  )
}

export default connect(mapProps, mapDispatch)(PrincipalInfos)